import { AspectRatio } from "app/animate/[[...id]]/CreateAnimationTypes";
import { RedactedDeforumSettings } from "app/types";

export const aspectRatios: AspectRatio[] = [
    {
        "name": "square",
        "label": "1:1",
        "width": 768,
        "height": 768
    },
    {
        "name": "landscape",
        "label": "16:9",
        "width": 1024,
        "height": 576
    },
    {
        "name": "portrait",
        "label": "9:16",
        "width": 576,
        "height": 1024
    }
];


export function settingsToAspectRatio(settings: RedactedDeforumSettings | undefined) : AspectRatio | undefined {
    if (!settings) {
        return undefined;
    }
    const ar = aspectRatios.find(ar => ar.width === settings.W && ar.height === settings.H);
    return ar;
}
